/* eslint-disable no-underscore-dangle */
import $ from 'jquery';
import Utility from './Utility';
import 'bootstrap-slider';
import 'bootstrap-switch';
import 'jquery-match-height';

const form = {

  booleans: $('.boolean-group'),
  ranges: $('.range-group'),
  metaRequestToken: $('meta[name="request_token"]'),
  messageKeys: ['success', 'warning', 'error', 'info'],

  init() {
    this.getCsrfToken();
    $('#doFormSubmit').removeClass('disabled').removeAttr('disabled');
    this.booleans = $('.boolean-group');
    this.ranges = $('.range-group');
    this.metaRequestToken = $('meta[name="request_token"]');
  },

  // # get the csrf token add add it to the jquery ajax setup
  getCsrfToken() {
    $.get('/app/frontend/session/csrf', (csrf) => {
      if (this.metaRequestToken.length) {
        this.metaRequestToken.attr('content', csrf);
      } else {
        $('head').append(`<meta content="${csrf}" name="request_token">`);
        this.metaRequestToken = $('meta[name="request_token"]');
      }
    });
  },
  csrfToken() {
    return this.metaRequestToken.attr('content');
  },
  getRequestToken() {},

};

if ($('meta[name=env]').attr('content') === 'local') {
  $('#hidden')
    .css({
      display: 'block',
      color: '#ff0000',
      'font-size': '20px',
      width: '500px',
      height: '40px',
    })
    .prop(
      'type', 'text',
    );
}

// if form.doGeoLocate is found get the location and create form inputs
$(() => {
  if ('geolocation' in navigator) {
    const glForm = $('form.doGeoLocate');
    if (glForm.length) {
      navigator.geolocation.getCurrentPosition((position) => {
        glForm.prepend(`<input type="hidden" name="geo_lat" value="${position.coords.latitude}" />`);
        glForm.prepend(`<input type="hidden" name="geo_long" value="${position.coords.longitude}" />`);
      });
    }
  }
});

// on submit of an ajax form
$('.doAjaxForm').submit((e) => {
  e.preventDefault();
  const thisForm = $(e.currentTarget);
  const fields = thisForm.serializeArray();
  const message = thisForm.find('.message-container');
  const url = thisForm.attr('action');
  const method = thisForm.attr('method').toUpperCase();
  const progress = thisForm.find('.progress-container');

  // make sure the form has an id
  if (!thisForm.attr('id')) {
    thisForm.attr('id', Utility.makeid());
  }

  const formId = thisForm.attr('id');

  // # check and see if there's already a container to hold the raw response
  if ($(`#${formId}-response-container`).length) {
    $(`#${formId}-response-container`).html('');
  } else {
    $('body').append(`<div id="${formId}-response-container" style="display: none"></div>`);
  }

  const formIdResponseContainer = $(`#${formId}-response-container`);

  // initial state of form notification
  progress.show();
  message.html('').hide();
  // reset any of the matched heights with the progress rotator
  $.fn.matchHeight._update();

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': form.csrfToken(),
    },
  });

  $.ajax({
    data: fields,
    url,
    method,
    dataType: 'JSON',
    success: (data) => {
      formIdResponseContainer.text(window.JSON.stringify(data));
      progress.hide();
      form.messageKeys.forEach((messageKey) => {
        if (Object.prototype.hasOwnProperty.call(data, messageKey)) {
          switch (messageKey) {
            case 'success':
              message.html(`<div class="alert alert-success"><p>${data.success.join('<br>')}</p></div>`).show();
              thisForm[0].reset();
              break;
            case 'warning':
            case 'error':
            case 'info':
              message
                .html(`<div class="alert alert-${messageKey}"><p>${data[messageKey].join('<br>')}</p></div>`)
                .show();
              break;
            default:
              break;
          }
        }
      });
      // # reset any of the matched heights with the progress rotator
      $.fn.matchHeight._update();
    },

    error: (jqXHR, textStatus) => {
      progress.hide();
      try {
        const jqXHRResponseText = JSON.parse(jqXHR.responseText);
        const mId = Utility.makeid();
        message.html(`<div class="alert alert-danger"><p id="${mId}"></p></div>`);
        // # get the inputs and check if there's a key on the response array with it
        thisForm.find('input, textarea').each((_index, el) => {
          if (Object.prototype.hasOwnProperty.call(jqXHRResponseText, $(el).attr('name'))) {
            $(`#${mId}`).append(`${jqXHRResponseText[$(el).attr('name')].join('<br>')}<br>`);
          }
        });
        message.show();
        // # reset any of the matched heights with the progress rotator
        $.fn.matchHeight._update();
      } catch (err) {
        message.html(`<div class="alert alert-danger"><p>Request failed: ${textStatus}</p></div>`).show();
        if ($('meta[name=env]').attr('content') === 'local') {
          // eslint-disable-next-line max-len
          message.html(`<div id="errorChecker" class="alert alert-danger"><p>Request failed: ${textStatus}</p><p>${jqXHR.responseText}</p></div>'`).show();
        }
      }
    },
  });
  return true;
});

if (form.ranges.length) {
  form.ranges.each((_index, el) => {
    const thisSliderInput = $(el).find('input[type="text"]');
    const thisSliderMin = $(el).find('.min');
    const thisSliderMax = $(el).find('.max');
    const thisSliderDefault = $(el).find('.default');
    const thisSliderLabel = $(el).find('label');
    thisSliderInput.slider(
      {
        tooltip: 'show',
        tooltip_position: 'bottom',
        min: parseInt(thisSliderMin.text(), 10),
        max: parseInt(thisSliderMax.text(), 10),
        value: parseInt(thisSliderDefault.text(), 10),
        labelledby: thisSliderLabel.attr('id'),
      },
    );
  });
}

if (form.booleans.length) {
  form.booleans.each((_index, el) => {
    const thisSwitch = $(el).find('input.boolean');
    if (thisSwitch.length > 0) {
      thisSwitch.bootstrapSwitch({
        state: false,
        onText: 'Yes',
        offText: 'No',
        wrapperClass: 'yesNoInput',
      });
      thisSwitch.on('switchChange.bootstrapSwitch', (event, state) => {
        $(event.currentTarget).attr('checked', state);
        if (state) {
          $(event.currentTarget).val('yes');
        } else {
          $(event.currentTarget).val('no');
        }
      });
    }
  });
}
export default form;
